export default "__VITE_ASSET__D2d4_qQ4__"